module.exports = __webpack_public_path__ + "static/img/gyas.6d1aa80.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gyas.png
// module id = v1ei
// module chunks = 0